import { render, staticRenderFns } from "./ProgressTabs.vue?vue&type=template&id=63e14a71"
import script from "./ProgressTabs.vue?vue&type=script&lang=js"
export * from "./ProgressTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports